// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.index-module__container--KfzKO{display:flex;justify-content:space-between;align-items:center;margin-top:15px}.index-module__side--sVPGo{display:flex;font-size:14px;color:dimgray;align-items:center}.index-module__toggle--R0mqw{gap:10px}.index-module__toggle--R0mqw.index-module__disabled--jm1eN{opacity:.5}.index-module__title--vSgtX{gap:20px}.index-module__counter--JEBuB{border:solid 1px dimgray;padding:2px 5px;border-radius:4px;margin-left:20px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `index-module__container--KfzKO`,
	"side": `index-module__side--sVPGo`,
	"toggle": `index-module__toggle--R0mqw`,
	"disabled": `index-module__disabled--jm1eN`,
	"title": `index-module__title--vSgtX`,
	"counter": `index-module__counter--JEBuB`
};
export default ___CSS_LOADER_EXPORT___;
